import React, { useEffect } from 'react'
import ls from 'local-storage';
import { useNavigate } from 'react-router-dom';

const Logout = (props) => {
  const navigate = useNavigate();

    useEffect(()=>{
      ls.clear();
          navigate('/login');
    },[props.history])
  return (
    <div className="c-app c-default-layout flex-row align-items-center">
    </div>
  )
}

export default Logout
